import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import moment from "moment";
import VueMoment from "vue-moment";
import store from "./store";
import { sync } from "vuex-router-sync";
import VueConfirmDialog from "vue-confirm-dialog";

import vueNumeralFilterInstaller from "vue-numeral-filter";
import { BootstrapVue } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import VueFormulate from "@braid/vue-formulate";
import "../node_modules/@braid/vue-formulate/themes/snow/snow.scss";

import draggable from "vuedraggable";

import VueClipboard from "vue-clipboard2";

sync(store, router);

Vue.config.devtools = true;
Vue.config.productionTip = true;

Vue.use(VueConfirmDialog);
Vue.component("vue-confirm-dialog", VueConfirmDialog.default);

Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);

Vue.use(VueMoment, { moment });
Vue.use(vueNumeralFilterInstaller, { locale: "sl" });

Vue.use(VueFormulate, {
  classes: {
    //outer: "form-group",
    //input: "form-control",
  },
});

Vue.use(draggable);

Vue.use(VueClipboard);

library.add(fas, fab);
Vue.component("font-awesome-icon", FontAwesomeIcon);

import Default from "./layout/Default.vue";
import NoHeader from "./layout/NoHeader.vue";
Vue.component("default-layout", Default);
Vue.component("no-header-layout", NoHeader);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
